import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Popover } from '@mui/material';
import { pickerButtonStyle, colorBoxStyle, colorBoxWrapper, colorBoxWrapperParent } from '../styles/customColorPickerStyle';
import { Iconify } from './index';

const CustomColorPicker = ({ open, colorList, value, onChange, anchorEl, handleClose, openColorPicker, style = {} }) => {
    const id = open ? 'simple-popover' : undefined;

    const handleKeyDown = (event, color) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onChange(color);
        }
    };

    const handlePickerKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            openColorPicker(event);
        }
    };

    return <Box sx={{ ...style }}>
        {value ? (
            <Box
                sx={{ ...pickerButtonStyle(value) }}
                onClick={openColorPicker}
                onKeyDown={handlePickerKeyDown}
                role="button"
                tabIndex={0}
                aria-label={`Selected color: ${value}. Click to change`}
                aria-haspopup="true"
                aria-expanded={open}
            />
        ) : (
            <Iconify
                icon='icons8:plus'
                width={24}
                height={24}
                onClick={openColorPicker}
                onKeyDown={handlePickerKeyDown}
                sx={{ cursor: 'pointer' }}
                role="button"
                tabIndex={0}
                aria-label="Add color"
                aria-haspopup="true"
                aria-expanded={open}
            />
        )}
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
        >
            <Box sx={colorBoxWrapperParent} role="listbox" aria-label="Color options">
                <Box sx={colorBoxWrapper}>
                    {colorList.map((ele, index) => (
                        <Box
                            key={index}
                            sx={{ ...colorBoxStyle(ele) }}
                            onClick={() => onChange(ele)}
                            onKeyDown={(e) => handleKeyDown(e, ele)}
                            role="option"
                            tabIndex={0}
                            aria-label={`Select color ${ele}`}
                            aria-selected={value === ele}
                        />
                    ))}
                </Box>
                {value && <Button variant="contained" sx={{ width: '100%', my: 1, fontSize: '11px' }} onClick={() => onChange('')}>Remove color</Button>}
            </Box>
        </Popover>
    </Box>;
};

export default CustomColorPicker;

CustomColorPicker.propTypes = {
    open: PropTypes.bool,
    colorList: PropTypes.any,
    value: PropTypes.string,
    onChange: PropTypes.func,
    handleClose: PropTypes.func,
    openColorPicker: PropTypes.func,
    anchorEl: PropTypes.any,
    style: PropTypes.any,
};